module.exports = __webpack_require__.p + "b53e4c8d8b2583bc3fb5fb6be3b2cafd.jpg";